import { FC } from 'react';

import { ArrowUpIcon } from '@/assets/icons';
import { CHANGE_INDICATOR_TEST_IDS } from '@/constants/data-testids.ts';

type ChangeIndicatorProps = {
  changeValue: number;
  valueUnit?: 'percent' | 'points';
};

export const ChangeIndicator: FC<ChangeIndicatorProps> = ({
  changeValue,
  valueUnit = 'percent',
}) => {
  const suffix = valueUnit === 'percent' ? '%' : '';

  if (changeValue > 0) {
    return (
      <div className="flex items-center text-custom-emerald-700">
        <ArrowUpIcon width={15} height={15} />
        <p data-testid={CHANGE_INDICATOR_TEST_IDS.VALUE} className="text-body-12-semibold">
          {changeValue}
          {suffix}
        </p>
      </div>
    );
  } else if (changeValue < 0) {
    return (
      <div className="flex items-center text-custom-red-700">
        <ArrowUpIcon width={15} height={15} className="rotate-180" />
        <p data-testid={CHANGE_INDICATOR_TEST_IDS.VALUE} className="text-body-12-semibold">
          {Math.abs(changeValue)}
          {suffix}
        </p>
      </div>
    );
  }

  const neutralValue = valueUnit === 'percent' ? '0%' : '0';

  return (
    <div className="flex items-center gap-0.5 text-custom-warm-grey-500">
      <span className="text-body-12-semibold" aria-hidden>
        —
      </span>
      <p data-testid={CHANGE_INDICATOR_TEST_IDS.VALUE} className="text-body-12-semibold">
        {neutralValue}
      </p>
    </div>
  );
};
